export default __webpack_public_path__ + "static/media/030.81a63a8c.jpg";